import { CheckoutStatus } from '@40seas/entities/checkout';
import { EnumColor } from '@40seas/frontend/common/providers';

export const checkoutStatusColorMapping = {
    [CheckoutStatus.Confirmed]: 'info',
    [CheckoutStatus.Charged]: 'success',
    [CheckoutStatus.Pending]: 'default',
    [CheckoutStatus.Refunded]: 'default',
    [CheckoutStatus.RefundFailed]: 'error',
    [CheckoutStatus.RefundInitiated]: 'default',
    [CheckoutStatus.Canceled]: 'error',
    [CheckoutStatus.Failed]: 'error',
    [CheckoutStatus.Disputed]: 'error',
    [CheckoutStatus.PartiallyPaid]: 'info',
    [CheckoutStatus.Initiated]: 'info',
    [CheckoutStatus.InTransit]: 'info',
    [CheckoutStatus.Scheduled]: 'info',
    [CheckoutStatus.MarkedAsPaid]: 'success',
    [CheckoutStatus.Overdue]: 'warning',
    [CheckoutStatus.Defaulted]: 'error',
} as { [key in CheckoutStatus]: EnumColor };
